export const GET_APPLICANTS_LOADING = "GET_APPLICANTS_LOADING";
export const GET_APPLICANTS_SUCCESS = "GET_APPLICANTS_SUCCESS";
export const GET_APPLICANTS_FAILURE = "GET_APPLICANTS_FAILURE";

export const GET_SELECT_APPLICANT_LOADING = "GET_SELECT_APPLICANT_LOADING";
export const GET_SELECT_APPLICANT_SUCCESS = "GET_SELECT_APPLICANT_SUCCESS";
export const GET_SELECT_APPLICANT_FAILURE = "GET_SELECT_APPLICANT_FAILURE";

export const REPORT_APPLICANTS_LOADING = "REPORT_APPLICANTS_LOADING";
export const REPORT_APPLICANTS_SUCCESS = "REPORT_APPLICANTS_SUCCESS";
export const REPORT_APPLICANTS_FAILURE = "REPORT_APPLICANTS_FAILURE";

export const CHANGE_APPLICATION_STATUS_LOADING =
  "CHANGE_APPLICATION_STATUS_LOADING";
export const CHANGE_APPLICATION_STATUS_SUCCESS =
  "CHANGE_APPLICATION_STATUS_SUCCESS";
export const CHANGE_APPLICATION_STATUS_FAILURE =
  "CHANGE_APPLICATION_STATUS_FAILURE";

export const SAVE_FEEDBACK_LOADING = "SAVE_FEEDBACK_LOADING";
export const SAVE_FEEDBACK_SUCCESS = "SAVE_FEEDBACK_SUCCESS";
export const SAVE_FEEDBACK_FAILURE = "SAVE_FEEDBACK_FAILURE";

export const SAVE_HELP_FEEDBACK_LOADING = "SAVE_HELP_FEEDBACK_LOADING";
export const SAVE_HELP_FEEDBACK_SUCCESS = "SAVE_HELP_FEEDBACK_SUCCESS";
export const SAVE_HELP_FEEDBACK_FAILURE = "SAVE_HELP_FEEDBACK_FAILURE";

export const GET_CONTACT_DETAILS_LOADING = "GET_CONTACT_DETAILS_LOADING";
export const GET_CONTACT_DETAILS_SUCCESS = "GET_CONTACT_DETAILS_SUCCESS";
export const GET_CONTACT_DETAILS_FAILURE = "GET_CONTACT_DETAILS_FAILURE";

export const GET_CANDIDATE_LISTING_FILTERS = "GET_CANDIDATE_LISTING_FILTERS";
